import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/logo-gotong-royong-indonesia.webp")